import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Heading.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var HeadingBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return _jsx(views.Heading, {
    variant: "pLarge",
    color: tokens.color,
    ref: ref,
    children: children
  });
});
var Heading = withDesignTokens(HeadingBase, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
export default Heading;